
const About = () => {
  const features = [
    {
      icon: 'ri-heart-line',
      title: 'Enhanced Quality of Life',
      description: 'Seniors at ProArk Haven enjoy a diverse range of activities tailored to their interests and abilities, fostering a sense of purpose and joy.'
    },
    {
      icon: 'ri-group-line',
      title: 'Social Connection',
      description: 'Our center is a social hub where friendships flourish, and laughter is abundant. We believe in the power of community to uplift and inspire.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Professional Care',
      description: 'Our team of dedicated professionals is passionate about making a positive impact in the lives of our members, ensuring their needs are met with expertise and warmth.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safety and Security',
      description: 'The well-being of our members is our top priority. Our center is designed to provide a safe and secure environment for all.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose ProArk Haven?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We believe every day is an opportunity to celebrate life with joy and dignity. Our comprehensive approach ensures your loved ones receive the care and attention they deserve.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${feature.icon} text-2xl text-orange-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              A Place Where Life Flourishes
            </h3>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              ProArk Haven is more than just an adult day care center – we're a community where seniors can thrive, connect, and continue to grow. Our state-of-the-art facility provides a warm, welcoming environment where every individual is valued and respected.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              From engaging recreational activities to professional healthcare support, we offer comprehensive services designed to enhance the physical, mental, and emotional well-being of our members while providing peace of mind for their families.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center">
                <div className="w-3 h-3 bg-orange-600 rounded-full mr-3"></div>
                <span className="text-gray-700">Licensed &amp; Certified</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-orange-600 rounded-full mr-3"></div>
                <span className="text-gray-700">Experienced Staff</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-orange-600 rounded-full mr-3"></div>
                <span className="text-gray-700">Family-Centered Care</span>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/7c9d61e1a99f56662e96e7b95a91b350.jpg"
              alt="Seniors enjoying activities at ProArk Haven"
              className="rounded-xl shadow-lg object-cover w-full h-96"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
